import React from 'react'
import styled from 'styled-components'
import { TableHeaders } from './table-headers.component'
import { TableRow } from './table-row.component'
import { Column } from '../../shared.styled'
import { SortOrderEnum } from '../../sort.utils'
import DotLoader from 'react-spinners/DotLoader'
import { Colors, Typography } from '../../../configs/styled.config'
import { VisibilityStatusEnum } from '../../shared.enums'

export interface ColumnCompanyProps {
    label: string
    key: string
    ratio: number
    visibility?: VisibilityStatusEnum
    renderFunction?: (value: any) => React.ReactNode
    onClick?: (header: string, order: SortOrderEnum) => void
    alignment?: 'flex-start' | 'center' | 'flex-end'
}

export interface TableCompanyValue extends Object {
    [key: string]: any
}

interface TableCompanyProps<T> {
    columns: ColumnCompanyProps[]
    values: T[]
    rowStyles?: (value: T) => React.CSSProperties
    onRowClick?: (value: T) => void
    isLoadingData?: boolean
}

export const TableCompany = <T extends TableCompanyValue>({
    columns,
    rowStyles,
    onRowClick,
    values,
    isLoadingData = false,
}: TableCompanyProps<T>) => {
    return (
        <Container>
            <TableHeaders columns={columns} />
            {isLoadingData ? (
                <LoaderContainer>
                    <DotLoader color={Colors['gold-pmauto']} size={100} />
                </LoaderContainer>
            ) : values.length === 0 ? (
                <StyledNoCompanies>
                    Não existem empresas com estes filtros
                </StyledNoCompanies>
            ) : (
                values.map((entity, idx) => (
                    <TableRow
                        rowStyles={rowStyles}
                        key={`row-${idx}`}
                        onClick={onRowClick}
                        columns={columns}
                        entity={entity}
                    />
                ))
            )}
        </Container>
    )
}

const Container = styled(Column as any)``

const LoaderContainer = styled('div')`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 200px;
`

const StyledNoCompanies = styled('div')`
    ${Typography.H1_Regular_Center};
    font-size: 20px;
`
